// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__Y13Df","header":"MessagesList_header__2wxIt","chat":"MessagesList_chat__11CiF"};